import { Line, mixins } from 'vue-chartjs'

export default Line.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [ {
                    gridLines: {
                        display: false
                    }
                }]
            }
        };

        this.renderChart(this.chartData, this.chartOptions);
    }
});



// WEBPACK FOOTER //
// ./src/tools/charts/SalesOverview.js